/**
 * Audit-log columns that hold JSON (requestBody, responseBody, error) arrive as TEXT. A row written by an older
 * service, or a value the service could not serialise, must render as text instead of breaking the table.
 */
export const parseAuditJson = (value: unknown): unknown => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};
